import { render, staticRenderFns } from "./LoginLogs.vue?vue&type=template&id=58081ca9&scoped=true"
import script from "./LoginLogs.vue?vue&type=script&lang=js"
export * from "./LoginLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58081ca9",
  null
  
)

export default component.exports